import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../constants/languages";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactPixel from "react-facebook-pixel";
import { getCookieConsentValue } from "react-cookie-consent";

const worldclassLogo = require("../img/trophy-worldclass.png");
const legendaryLogo = require("../img/trophy-legendary.png");
const proLogo = require("../img/trophy-pro.png");

export default class UpgradeStatusDialog extends React.Component {
  state = {
    upgrade: {},
    upgradeLoaded: false,
    open: true,

    analyticsTriggered: false,
    fbPixelTriggered: false,
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  triggerAnalytics = () => {
    if (window.firebase.analytics) {
      if (this.state.upgrade.package === 1) {
        window.firebase.analytics().logEvent("upgrade_success_worldclass");
        window.firebase.analytics().logEvent("purchase", {
          value: 40,
          tax: 7,
          currency: "EUR",
          items: [
            {
              name: "Worldclass",
              price: 33,
            }
          ]
        });
        this.setState({ analyticsTriggered: true });
      } else if (this.state.upgrade.package === 2) {
        window.firebase.analytics().logEvent("upgrade_success_legendary");
        window.firebase.analytics().logEvent("purchase", {
          value: 120,
          tax: 21,
          currency: "EUR",
          items: [
            {
              name: "Legendary",
              price: 99,
            }
          ]
        });
        this.setState({ analyticsTriggered: true });
      } else if (this.state.upgrade.package === 3) {
        window.firebase.analytics().logEvent("upgrade_success_pro");
        window.firebase.analytics().logEvent("purchase", {
          value: 20,
          tax: 4,
          currency: "EUR",
          items: [
            {
              name: "Pro",
              price: 16,
            }
          ]
        });
        this.setState({ analyticsTriggered: true });
      }
    }
  };

  triggerFB = () => {
    let consent = getCookieConsentValue();
    if (consent === "true") {
      ReactPixel.init("802314050594771");
      if (this.state.upgrade.package === 1) {
        ReactPixel.track("Purchase", {
          value: "33",
          currency: "EUR",
        });
        this.setState({ fbPixelTriggered: true });
      } else if (this.state.upgrade.package === 2) {
        ReactPixel.track("Purchase", {
          value: "99",
          currency: "EUR",
        });
        this.setState({ fbPixelTriggered: true });
      } else if (this.state.upgrade.package === 3) {
        ReactPixel.track("Purchase", {
          value: "16",
          currency: "EUR",
        });
        this.setState({ fbPixelTriggered: true });
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("upgrades")
      .where("tournamentId", "==", this.props.tournament[".key"])
      .where("uid", "==", this.props.tournament.uid)
      .onSnapshot((querySnapshot) => {
        let upgrades = [];
        querySnapshot.forEach((doc) => {
          upgrades.push(doc.data());
        });
        upgrades.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
        this.setState({ upgrade: upgrades[0] || {}, upgradeLoaded: true });
        if (
          !this.state.analyticsTriggered &&
          (upgrades[0] || {}).status === 1
        ) {
          this.triggerAnalytics();
        }
        if (!this.state.fbPixelTriggered && (upgrades[0] || {}).status === 1) {
          this.triggerFB();
        }
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.state.upgradeLoaded === false || this.state.upgrade.status === 0
            ? languages.upgrade.processUpgrade
            : this.state.upgrade.status === 1
            ? languages.upgrade.upgradeSuccess
            : languages.upgrade.upgradeFail}
        </DialogTitle>
        <DialogContent
          style={{ width: 600, maxWidth: "100%", textAlign: "center" }}
        >
          {(this.state.upgradeLoaded === false ||
            this.state.upgrade.status === 0) && (
            <span>
              <CircularProgress />
              <br />
              {languages.upgrade.processUpgrade}
            </span>
          )}
          {this.state.upgrade.status === 1 && (
            <span>
              {this.state.upgrade.package === 1 && (
                <span>
                  <img style={{ height: 80 }} src={worldclassLogo} alt="" />
                  <br />
                  {languages.tournamentStatus[1].name}
                </span>
              )}
              {this.state.upgrade.package === 2 && (
                <span>
                  <img style={{ height: 80 }} src={legendaryLogo} alt="" />
                  <br />
                  {languages.tournamentStatus[2].name}
                </span>
              )}
              {this.state.upgrade.package === 3 && (
                <span>
                  <img style={{ height: 80 }} src={proLogo} alt="" />
                  <br />
                  {languages.tournamentStatus[3].name}
                </span>
              )}
              <br />
              <br />
              {languages.upgrade.paymentSuccess}
              <br />
              <br />
              <Button
                onClick={this.toggleDialog}
                variant="contained"
                color="primary"
              >
                {languages.upgrade.letsGo}
              </Button>
            </span>
          )}
          {this.state.upgrade.status === 2 && (
            <span>
              {languages.upgrade.paymentFail}
              <br />
              <br />
              <Button
                onClick={this.toggleDialog}
                variant="contained"
                color="primary"
              >
                {languages.upgrade.close}
              </Button>
            </span>
          )}
        </DialogContent>
      </Dialog>
    );
  }
}
